import { useMutation, useQueryClient } from 'react-query';

import api from '../api';

import useProject from './useProject';
import { ProjectTemplate } from '@experiment-management-shared/types';

type SetDefaultParams = {
  projectId: string;
  viewId?: string;
};
const selectDefaultProject = ({ projectId, viewId }: SetDefaultParams) => {
  if (!viewId) {
    return api.post('dashboard-templates/project/remove', {
      projectId
    });
  }

  return api.post('dashboard-templates/project/set', {
    project_id: projectId,
    template_id: viewId
  });
};

export default function useSelectDefaultProjectMutation() {
  const { data: project } = useProject();
  const queryClient = useQueryClient();
  const projectId = project?.projectId;

  return useMutation(
    ({ viewId }: { viewId?: string }) =>
      selectDefaultProject({ projectId: project?.projectId, viewId }),
    {
      onMutate: async ({ viewId }) => {
        await queryClient.cancelQueries(['projectViews', { projectId }]);

        const prevData: ProjectTemplate[] =
          queryClient.getQueryData(['projectViews', { projectId }]) || [];

        queryClient.setQueryData(
          ['projectViews', { projectId }],
          [
            ...prevData.map(oldView => ({
              ...oldView,
              projectDefault: viewId === oldView.templateId
            }))
          ]
        );

        return { prevData };
      },
      onError: (e, _, context) => {
        queryClient.setQueryData(
          ['projectViews', { projectId }],
          context?.prevData
        );
      },
      onSuccess: async () => {
        await queryClient.invalidateQueries(['projectViews', { projectId }]);
      }
    }
  );
}
